import { LineAlertTriangle } from '@qr-front/icons/line-alert-triangle'
import { ROUTES } from 'constants/routesConstants'
import { getFixPaymentRoute } from 'features/purchase/utils/misc'
import { Subscription, UserStatusEnum } from 'types/subscription'

import { TRouter } from '@/i18n-routing'
import { TSvgIcon, TTranslationFunction } from '@/types'

import { reactivateSubscription } from '../Subscription/reactivateSubscription'

export type TBannerConfig = {
	type: 'info' | 'error'
	Icon: TSvgIcon
	title: string
	description: string
	actionLabel: string
	onAction: () => void
}

export const bannerConfig = (
	router: TRouter,
	subscription: Subscription,
	t: TTranslationFunction,
): Partial<Record<UserStatusEnum, TBannerConfig>> => {
	return {
		[UserStatusEnum.PREMIUM_CANCELLED]: {
			type: 'info',
			Icon: LineAlertTriangle,
			title: t('dashboard__premium_cancelled__banner_title'),
			description: t('dashboard__premium_cancelled__banner_description'),
			actionLabel: t('dashboard__reactivate__button'),
			onAction: () => {
				router.push(ROUTES.plans)
			},
		},
		[UserStatusEnum.PREMIUM_CANCELLING]: {
			type: 'info',
			Icon: LineAlertTriangle,
			title: t('dashboard__premium_cancelling__banner_title'),
			description: t('dashboard__premium_cancelling__banner_description'),
			actionLabel: t('dashboard__reactivate__button'),
			onAction: async () => await reactivateSubscription(subscription, t),
		},
		[UserStatusEnum.PREMIUM_UNPAID]: {
			type: 'info',
			Icon: LineAlertTriangle,
			title: t('dashboard__premium_unpaid__banner_title'),
			description: t('dashboard__premium_unpaid__banner_text'),
			actionLabel: t('dashboard__premium_unpaid__banner_button'),
			onAction: () => {
				router.push(getFixPaymentRoute(subscription))
			},
		},
		[UserStatusEnum.PREMIUM_IN_DEBT]: {
			type: 'info',
			Icon: LineAlertTriangle,
			title: t('dashboard__premium_in_debt__banner_title'),
			description: t('dashboard__premium_in_debt__banner_description'),
			actionLabel: t('dashboard__reactivate__button'),
			onAction: () => {
				router.push(ROUTES.plans)
			},
		},
	}
}

export const deactivatedBannerConfig = (
	router: TRouter,
	t: TTranslationFunction,
): TBannerConfig => {
	return {
		type: 'info',
		Icon: LineAlertTriangle,
		title: t('dashboard__deactivated__banner_title'),
		description: t('dashboard__deactivated__banner_description'),
		actionLabel: t('dashboard__deactivated__banner_button'),
		onAction: () => {
			router.push(ROUTES.plans)
		},
	}
}
